/*
 Form runs off given layout prop. Also has ID...

*/

import React, { useState, useEffect } from 'react';
import { Field, reduxForm, change, FieldArray, arrayPush, arrayRemove } from 'redux-form';
import {
	Container,
	Header,
	InputGroup,
	Content,
	Text,
	Label,
	Input,
	Icon,
	Toast,
	Form,
	Spinner,
	View,
	Left,
	Right,
	Body,
	Button,
	Title,
	Card,
	CardItem,
	H3,
	ListItem,
	Picker as nbPicker,
	Separator
} from 'native-base';
import { LayoutAnimation, Switch, Picker as rnPicker, Platform, Linking } from 'react-native';
import { textInput, moneyInput, renderPicker, renderDateField, picInput, renderSwitch, numberInput, displayInput, renderCheckbox } from '../../forms/taxComponents';
import BusTypeContainer from '../Signup/busTypeContainer';
import FormSelector from './formSelector';
import * as _ from 'lodash';
import { A } from '@expo/html-elements';

import * as saValidator from './validators';
import OnPageHelp from '../../components/onPageHelp';
const Picker = Platform.OS == 'ios' ? nbPicker : rnPicker;

const inputs = {
	text: textInput,
	money: moneyInput,
	picker: renderPicker,
	date: renderDateField,
	switch: renderSwitch,
	number: numberInput,
	display: displayInput //needs name, displays loaded val
};

function syncValidate(values, props) {
	if (!props || Object.keys(values).length === 0) return; //don't validate until the initialValues have arrived - prevents off then ons
	//runs constantly as value changes. If you want blur, use asyncValidate
	//console.log(props, 'syncValidate', props.pristine ? 'pristine' : 'dirty');
	const animate = !props.pristine && Platform.OS != 'android';

	props.layout.boxes &&
		props.layout.boxes.forEach((box, i) => {
			//.visible is a pointer to the value this depends on
			//OR a formula based on values!

			if (box.visible) _shouldBoxBeVisible(box.visible, box.name, props.setHidden, values, !props.pristine, animate);
			if (box.formula) _calcFormula(box.formula, box.name, props.setBox, values);
			if (box.addRemove) _addRemove(box.name, box.addRemove, values, props.dispatch);

			box.items &&
				box.items.forEach(subBox => {
					if (subBox.visible) _shouldBoxBeVisible(subBox.visible, subBox.name, props.setHidden, values, !props.pristine, animate);
					if (subBox.formula) _calcFormula(subBox.formula, subBox.name, props.setBox, values);
					if (subBox.addRemove) _addRemove(subBox.name, subBox.addRemove, values, props.dispatch);
				});
		});
}

function _shouldBoxBeVisible(visiFormula, name, setHidden, values, wasTouched, animate) {
	//__DEV__ && console.log('Be visible ??? ', arguments);
	if (visiFormula.indexOf(':') == 0) {
		//formula
		const f = '(' + visiFormula.substring(1).replace(/\[/g, "values['").replace(/\]/g, "'] ") + ')';
		const val = eval(f);
		setHidden(name, !val, wasTouched, false); // animate);
	} else if (typeof values[visiFormula] == 'boolean' || typeof values[visiFormula] == 'string') {
		const hideIt = visiFormula.indexOf('!') == 0 ? !!(values[visiFormula.substring(1)] - 0) : !(values[visiFormula] - 0);
		//__DEV__ && console.log('Be hidden ! ', name, hideIt);
		setHidden(name, hideIt, wasTouched, false); // animate);
	}
}

function _calcFormula(formula, name, setBox, vals) {
	let f = '(' + formula.replace(/(^|[^!])\[([A-Z0-9_\-x]+)\]/g, "$1parseFloat(vals['$2'] || 0)").replace(/!\[([A-Z0-9_\-x]+)\]/g, "!vals['$1']") + ')';

	//console.log(f);
	try {
		const val = eval(f);
		//console.log(val, name);
		if (val !== false && val != vals[name]) setBox(name, val ? val.toFixed(2) : '0');
	} catch (e) {
		__DEV__ && console.log('failed eval:', f, vals, e);
	}
}

function _addRemove(field, details, allVals, dispatch) {
	//console.log('_addRemove', there, field, allVals[field]);
	if (allVals[field] === undefined) return;
	if (allVals[field] && allVals[field] !== '0') {
		//console.log('ADDDDDD', there == -1);
		//add details.item to details.field if not there
		const there = _.findIndex(allVals[details.field], { name: details.item.name, show: true });
		if (there == -1) dispatch(arrayPush('sa', details.field, details.item));
	} else {
		//console.log('REMOOOOVE', there > -1);
		//remove
		const there = _.findIndex(allVals[details.field], { name: details.item.name, auto: true }); //only remove one we put there
		if (there > -1) dispatch(arrayRemove('sa', details.field, there));
	}
}

function switchedHeader(props) {
	const { input, title, custom, disabled, onVal = 'Yes', offVal = 'No', icon, onNonBool = true, offNonBool = false, labelWidth = '80%', style = {}, boxno, visible, children } = props;
	const flex = !!labelWidth ? null : 0.5;
	const isQuestion = title && title.substring(title.length - 1) == '?';

	return (
		<Card style={{ flexWrap: 'nowrap' }}>
			<Separator style={[{ paddingLeft: 5, paddingTop: 2, paddingBottom: 2, flex: 1, backgroundColor: '#b4d7ea' }, style, { flexDirection: 'row', width: '100%', marginLeft: 0 }]}>
				{!!boxno && <Text style={{ borderColor: '#000', fontSize: 20, borderWidth: 1, margin: 2, padding: 5, flex: null, marginLeft: 15 }}>{boxno}</Text>}

				<Button full transparent onPress={() => input.onChange(!input.value)} style={{ alignSelf: 'center' }}>
					{!!icon && <Icon name={icon} size={14} style={{ fontSize: 18, alignSelf: 'center', color: '#2f6483' }} />}

					<Label style={{ flex, color: '#2f6483', width: labelWidth, fontSize: boxno ? 20 : 16 }}>{title}</Label>

					{!isQuestion && !!visible && <Icon name={input.value ? 'arrow-dropup' : 'arrow-dropdown'} />}
					{isQuestion && !!visible && <Text>{input.value ? 'Yes' : 'No'}</Text>}
				</Button>
			</Separator>
			{children}
		</Card>
	);
}

function renderBox(box, i, setHelpPath, lists, reloadLayout) {
	//console.log('renderBox', box, i, lists);
	//const { handleSubmit, pristine, reset, submitting, layout, figs, year, formName } = props;

	if (box.type == 'label' && !box.doHide)
		return (
			<Text key={'l' + i} style={{ paddingHorizontal: 8 }}>
				{box.label}
			</Text>
		);
	if (box.type == 'separator' && !box.doHide)
		return (
			<Separator
				key={'se' + i}
				style={{
					flexDirection: 'row',
					justifyContent: 'flex-start',
					marginBottom: 5,
					marginTop: 10,
					borderBottomColor: '#AAA',
					borderBottomWidth: 1,
					alignItems: 'center',
					backgroundColor: '#d9ebf5',
					flexWrap: 'wrap',
					flex: 1,
					flexGrow: 1
				}}>
				{!!box.boxno && <Text style={{ borderColor: '#EEE', fontSize: 20, borderWidth: 1, margin: 0, padding: 2, flex: null, marginRight: 10 }}>{box.boxno}</Text>}
				{!!box.label && <Text style={{ fontSize: 18, color: '#2f6483' }}>{box.label}</Text>}
				{!!box.text && <Text style={{ fontSize: 16, color: '#222' }}>{box.text}</Text>}
				{!!box.link && (
					<A href={box.link} target="_blank">
						<Text style={{ marginHorizontal: 10, fontSize: 14, fontWeight: '600' }}>{box.linkLabel || 'Open'}</Text>
						<Icon name="ios-open" style={{ color: 'grey', fontSize: 14 }} />
					</A>
				)}
			</Separator>
		);

	if (box.type == 'switchedset') {
		//similar to fieldset but switch is in header separator; doHide affects only children
		return (
			<Field key={box.name} component={switchedHeader} {...box}>
				{!!box.subLabel && (
					<Text note key={i} style={{ paddingLeft: 20, paddingRight: 4, width: '100%' }}>
						{box.subLabel}
					</Text>
				)}
				{!box.doHide && box.items.map((item, j) => renderBox(item, `${i}sw ${j}`, setHelpPath, lists, reloadLayout))}
			</Field>
		);
	}

	if (box.type == 'fieldset' && !box.doHide)
		return (
			<View key={box.name || 'fs' + i} style={{ backgroundColor: '#fdfeff', flexDirection: 'column', borderColor: '#CCC', borderWidth: 1, margin: 2 }}>
				{!!box.title && (
					<Separator style={{ backgroundColor: '#dbf2ff', color: '#2f6483', borderBottomColor: '#AAA' }}>
						<H3>{box.title}</H3>
					</Separator>
				)}

				{box.items.map((item, j) => renderBox(item, `${i}fs ${j}`, setHelpPath, lists, reloadLayout))}
			</View>
		);

	if (box.type == 'picker' && !box.doHide) {
		const { options, list, ...restBox } = box;
		//console.log(options);
		return (
			<React.Fragment key={box.name}>
				<Field
					key={box.name}
					component={renderPicker}
					{...restBox}
					labelPress={
						box.onPageHelp
							? () => {
									setHelpPath(box.onPageHelp);
							  }
							: null
					}>
					{options
						? options.map((option, j) => <Picker.Item key={j} label={option.display} value={option.id} />)
						: lists[list].map((option, j) => <Picker.Item key={j} label={option.display} value={option.id} />)}
				</Field>
				{!!box.subLabel && (
					<Text note key={box.name + '-n'} style={{ paddingLeft: 20, paddingRight: 4, width: '100%' }}>
						{box.subLabel}
					</Text>
				)}
			</React.Fragment>
		);
	}

	if (box.type == 'busTypes' && !box.doHide) {
		return (
			<Field
				// style={{ flex: 1 }}
				title="What Kind of Business?"
				label="Business"
				key={box.name}
				labelWidth={120} //cant find that 16 and 5 padding!!
				buttonText="Find your business type"
				component={BusTypeContainer}
				name={box.name}
				disableInit
				data={box.list && lists[box.list]}
				onChange={(event, newValue, previousValue, name) => {
					box.reloadOnChange && newValue != previousValue && setTimeout(reloadLayout, 200);
				}}
			/>
		);
	}

	if (box.type == 'formSelect') {
		return <FieldArray name={box.name} key={box.name} component={FormSelector} list={lists[box.list]} />;
	}

	if (!box.doHide)
		return (
			<Field
				key={box.name}
				component={inputs[box.type]}
				allowDecimals={true}
				{...box}
				noIcon
				labelPress={
					box.onPageHelp
						? () => {
								setHelpPath(box.onPageHelp);
						  }
						: null
				}
				labelWidth={!box.labelWidth && box.type == 'switch' && !(box.offVal || box.onVal) ? '70%' : '60%'}
				validate={box.valType && [saValidator[box.valType]]}>
				{!!box.subLabel && !box.subLabelLink && (
					<Text note key={i} style={{ paddingLeft: 20, paddingRight: 4, width: '100%' }}>
						{box.subLabel}
					</Text>
				)}
				{!!box.subLabelLink && (
					<A href={box.subLabelLink} target="_blank" style={{ paddingLeft: 20, paddingRight: 4, width: '100%' }}>
						<Text note>{box.subLabel}</Text>
						<Icon name="ios-open" style={{ color: 'grey', fontSize: 16, marginLeft: 20 }} />
					</A>
				)}
			</Field>
		);
}

function SaForm(props, what) {
	const { handleSubmit, pristine, reset, submitting, layout, figs, year, formName, jwt, reloadLayout, initialValues } = props;
	const [helpPath, setHelpPath] = useState(null);

	//console.log(helpPath);
	if (!!figs && !layout.firstValidate) {
		__DEV__ && console.log('-- first validate --', figs, props.layout);
		layout.firstValidate = true; //I know it's a prop!!
		syncValidate(figs, props);
	}

	return (
		<Form>
			<OnPageHelp path={helpPath} setHelpPath={setHelpPath} />
			{!!layout.boxes && layout.boxes.map((box, i) => renderBox(box, i, setHelpPath, layout.lists, reloadLayout))}
		</Form>
	);
}

export default reduxForm({
	form: 'sa', // a unique identifier for this form
	validate: syncValidate
})(SaForm);
